var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationFeaturesTab2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 478,
    height: 416,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 350,
    height: 346,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 200,
    height: 255,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "117.5%",
    height: "113.7%",
    x: "-8.8%",
    y: "-4.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.285332669 0 0 0 0 0.363695184 0 0 0 0 0.811480978 0 0 0 0.0830692745 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "139.5%",
    height: "131%",
    x: "-19.8%",
    y: "-13.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.285332669 0 0 0 0 0.363695184 0 0 0 0 0.811480978 0 0 0 0.0830692745 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "g",
    width: 200,
    height: 255,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: "117.5%",
    height: "113.7%",
    x: "-8.8%",
    y: "-4.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.285332669 0 0 0 0 0.363695184 0 0 0 0 0.811480978 0 0 0 0.0830692745 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E8EAF6",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242A45",
    d: "M-3.53.197h547v59h-547z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.47 14.197)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    opacity: 0.245
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    opacity: 0.75,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    y: 14,
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 138)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 168)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    transform: "translate(251 138)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FA5959"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 168)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 34,
    x: 27,
    y: 85,
    fill: "#FFF",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#5267DF",
    strokeWidth: 20,
    transform: "translate(305 102)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 67,
    r: 67,
    fill: "#495DCF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M114 115l49 49"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFeaturesTab2);
export default __webpack_public_path__ + "static/media/illustration-features-tab-2.101149f0d8d942b78044414c2170b040.svg";
export { ForwardRef as ReactComponent };